<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18.21" height="22.663" viewBox="0 0 18.21 22.663">
    <g transform="translate(-372.396 -389.168)">
      <path
        d="M390.6,411.831H372.4l.008-.508s.026-1.633,0-2.555a4.154,4.154,0,0,1,2.214-3.916,12.982,12.982,0,0,1,3.952-.827l.3-1.837c-.134-.109-.339-.272-.65-.516-1.464-1.15-1.678-2.941-1.772-4.676a7.417,7.417,0,0,1,0-2.083l.061-.43h9.973l.014.485c0,.06.043,1.475,0,2.04a9.113,9.113,0,0,1-.552,3.206l-.059.114a7.224,7.224,0,0,1-1.983,1.937l.236,1.762a15.757,15.757,0,0,1,4.924.822c1.577.8,1.547,3.6,1.539,3.919Zm-17.194-1H389.6v-2.077c.016-.651-.132-2.574-.994-3.015a16.9,16.9,0,0,0-4.921-.727l-.426-.011-.436-3.25.284-.169a6.215,6.215,0,0,0,1.917-1.77,8.211,8.211,0,0,0,.472-2.838c.027-.348.021-1.027.012-1.491h-8.117a6.506,6.506,0,0,0,.047,1.415c.106,1.93.367,3.18,1.4,3.987,1.161.912,1.314,1.032,1.024,1.438l-.437,2.682-.418.007a11.936,11.936,0,0,0-3.981.751,3.149,3.149,0,0,0-1.622,2.961C373.42,409.345,373.416,410.264,373.41,410.831Z"
        fill="#777"
      />
      <rect
        width="1"
        height="2.248"
        transform="translate(375.102 409.008)"
        fill="#777"
      />
      <rect
        width="1"
        height="2.199"
        transform="translate(386.754 409.127)"
        fill="#777"
      />
      <path
        d="M381.422,410.632a3.541,3.541,0,0,1-2.723-1.616l-.081-.139a19.99,19.99,0,0,1-1.065-3.931l.987-.162a19.041,19.041,0,0,0,.984,3.664,2.7,2.7,0,0,0,1.9,1.184h.012a3.146,3.146,0,0,0,2.244-1.514,8.4,8.4,0,0,0,.553-3.484l1-.055a9.378,9.378,0,0,1-.647,3.972l-.066.117a4.1,4.1,0,0,1-3.074,1.964Z"
        fill="#777"
      />
      <path
        d="M375.968,410.962l-.756-.654c.88-1.017,1.047-4.136,1.038-5.252l1-.01C377.254,405.495,377.253,409.479,375.968,410.962Z"
        fill="#777"
      />
      <path
        d="M386.877,410.962c-1.284-1.483-1.285-5.467-1.28-5.916l1,.01c-.01,1.116.157,4.235,1.036,5.252Z"
        fill="#777"
      />
      <path
        d="M381.451,402.875a7.09,7.09,0,0,1-2.542-.506l.357-.933c2.769,1.06,4.28-.123,4.342-.173l.638.77A4.527,4.527,0,0,1,381.451,402.875Z"
        fill="#777"
      />
      <path
        d="M386.361,396.572l-.087-1,.953-.083V394.5l-1.181-.178-.08-.326c-.038-.155-.981-3.81-4.575-3.828h-.027a4.332,4.332,0,0,0-4.228,3.588l-.063.348-1.213.2v1.148h1.078v1H374.86v-3l1.379-.223a5.264,5.264,0,0,1,5.124-4.06h.033c3.681.019,5.08,3.211,5.44,4.262l1.391.209v2.77Z"
        fill="#777"
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(379.426 396.522)"
        fill="#777"
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(382.426 396.522)"
        fill="#777"
      />
      <path
        d="M381.357,400.922a4.717,4.717,0,0,1-1.489-.241l.315-.949a3.722,3.722,0,0,0,2.625-.1l.391.921A4.724,4.724,0,0,1,381.357,400.922Z"
        fill="#777"
      />
      <rect
        width="1"
        height="1.673"
        transform="translate(380.896 397.521)"
        fill="#777"
      />
    </g>
  </svg>
</template>
